const getTempoVariations = (commonCanopies, commonVariaton) => {
	return {
		'5770': {
			...commonVariaton,
			size: {
				width: 0.25,
				height: 0.177,
				depth: 0.25
			},
			paddingTop: -1,
			familyName: 'tempo',
			related: ['5770', '5772', '5774'],
			canopy: {
				...commonCanopies,
				"10": {
					...commonCanopies['10'],
					source: '/models/canopy_skan.glb',
					size: {
						width: 0.16,
						depth: 0.16,
						height: 0.033
					},
				}
			},
			light: {
				type: 'spot',
				power: 199,
				options: { angle: Math.PI / 8 }
			}
		},
        '5772': {
			...commonVariaton,
			size: {
				width: 0.13,
				height: 0.268,
				depth: 0.13
			},
			paddingTop: -1,
			familyName: 'tempo',
			related: ['5770', '5772', '5774'],
			canopy: {
				...commonCanopies,
				"10": {
					...commonCanopies['10'],
					source: '/models/canopy_skan.glb',
					size: {
						width: 0.16,
						depth: 0.16,
						height: 0.033
					},
				}
			},
			light: {
				type: 'spot',
				power: 199,
				options: { angle: Math.PI / 8 }
			}
		},
        '5774': {
			...commonVariaton,
			size: {
				width: 0.205,
				height: 0.29,
				depth: 0.205
			},
			paddingTop: -1,
			familyName: 'tempo',
			related: ['5770', '5772', '5774'],
			canopy: {
				...commonCanopies,
				"10": {
					...commonCanopies['10'],
					source: '/models/canopy_skan.glb',
					size: {
						width: 0.16,
						depth: 0.16,
						height: 0.033
					},
				}
			},
			light: {
				type: 'spot',
				power: 199,
				options: { angle: Math.PI / 8 }
			}
		}
	}
}

export default getTempoVariations